import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiStateSelectModule } from '../lib/shared-ui-state-select.module'
import { ProvinceSelectExampleComponent } from './state-select-docs/examples/province-select-example.component'
import { StateProvinceSelectExampleComponent } from './state-select-docs/examples/state-province-select-example.component'
import { StateSelectExampleComponent } from './state-select-docs/examples/state-select-example.component'
import { StateSelectDocsComponent } from './state-select-docs/state-select-docs.component'


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiStateSelectModule
  ],
  declarations: [
    StateSelectDocsComponent,
    ProvinceSelectExampleComponent,
    StateProvinceSelectExampleComponent,
    StateSelectExampleComponent
  ],
  exports: [
    StateSelectDocsComponent
  ]
})
export class SharedUiStateSelectDocsModule {}
